<template>
  <footer>
      <div class="footer-wrap text-center">
        
      <ul class="list-inline mb-0" id="footer-nav" v-html="$t('Footer.Links')">  
      </ul>
    </div> 
    
    <p class="mt-3 text-center">
        <small
          >© {{ new Date().getFullYear() }}. {{$t('Footer.AllrightReserved')}}</small
        >
      </p>
    
    
    
 
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>


